/** Posts per page on the /blog/ listing (the API's `limit`). */
export const BLOG_PAGE_SIZE = 10

/** Crawlable URL of a blog listing page: page 1 is `/blog/`, the rest `/blog/page/<n>/`. */
export function blogPageHref(page: number): string {
  return page <= 1 ? '/blog/' : `/blog/page/${page}/`
}
